/**
 * Format ISO datetime strings for display in browser's local timezone
 *
 * @param {string|Date} date - ISO datetime string (e.g., "2025-11-14T12:00:00.000Z") or Date object
 * @param {number} digits - Number of fractional second digits (0-3), default 0
 * @param {string} format - Output format: 'day', 'minutes', 'full' (default)
 * @returns {string|null} Formatted date string in local timezone, or null if invalid
 *
 * Examples:
 * - displayIsoDate('2025-11-14T12:00:00.000Z', 0, 'day')
 *    → '2025-11-14'
 *
 * - displayIsoDate('2025-11-14T12:00:00.000Z', 0, 'minutes')
 *    → '2025-11-14 13:00' (if local is UTC+1)
 *
 * - displayIsoDate('2025-11-14T12:00:00.000Z', 0, 'full')
 *    → '2025-11-14 13:00:00' (if local is UTC+1)
 *
 * - displayIsoDate('2025-11-14T12:00:00.123Z', 2, 'full')
 *    → '2025-11-14 13:00:00.12'
 */
function displayIsoDate(date, digits = 0, format = 'full') {
  if (!date) return null;

  const d = new Date(date);

  if (Number.isNaN(d.getTime())) return null;

  const pad = (n, len = 2) => String(n).padStart(len, '0');

  const YYYY = d.getFullYear();
  const MM = pad(d.getMonth() + 1);
  const DD = pad(d.getDate());
  const hh = pad(d.getHours());
  const mm = pad(d.getMinutes());

  if (format === 'day') {
    return `${YYYY}-${MM}-${DD}`;
  }

  if (format === 'minutes') {
    return `${YYYY}-${MM}-${DD} ${hh}:${mm}`;
  }

  // 'full' format
  const ss = pad(d.getSeconds());

  if ((digits > 0) && (digits < 4)) {
    const ms = d.getMilliseconds();
    const fraction = `.${String(ms).padStart(3, '0').slice(0, digits)}`;

    return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss}${fraction}`;
  }

  return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
}

export default displayIsoDate;
